import {
  REALTIME_INSTRUCTIONS_CLUSTER_REPLY,
  WELCOME_MESSAGE_CLUSTER_REPLY
} from '@/config/realtime-instructions';
import { getMetroRealtimeInstructions, WELCOME_MESSAGE_METRO } from '@/config/metro-instructions';
import { getProvinzialRealtimeInstructions, WELCOME_MESSAGE_PROVINZIAL } from '@/config/provinzial-instructions';
import { getCupraRealtimeInstructions, WELCOME_MESSAGE_CUPRA } from '@/config/cupra-instructions';
import { initializeClusterReplyTools, initializeCupraTools, initializeMetroTools, initializeProvinzialTools } from '@/tools';

export function initializeActiveUseCaseTools(useCase: string) {
  switch (useCase) {
    case 'metro':
      initializeMetroTools();
      break;
    case 'provinzial':
      initializeProvinzialTools();
      break;
    case 'cupra':
      initializeCupraTools();
      break;
    default:
      initializeClusterReplyTools();
      break;
  }
}

export function getActiveInstructions(useCase: string): string {
  switch (useCase) {
    case 'metro':
      return getMetroRealtimeInstructions();
    case 'provinzial':
      return getProvinzialRealtimeInstructions();
    case 'cupra':
      return getCupraRealtimeInstructions();
    default:
      return REALTIME_INSTRUCTIONS_CLUSTER_REPLY;
  }
}

export function getActiveWelcomeMessage(useCase: string): string {
  switch (useCase) {
    case 'metro':
      return WELCOME_MESSAGE_METRO;
    case 'provinzial':
      return WELCOME_MESSAGE_PROVINZIAL;
    case 'cupra':
      return WELCOME_MESSAGE_CUPRA;
    default:
      return WELCOME_MESSAGE_CLUSTER_REPLY;
  }
}
